"use client";

import { useEffect, useState } from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

type SocialShareProps = {
  url?: string;
  title?: string;
};

const SocialShare = ({ url, title }: SocialShareProps) => {
  const [content, setContent] = useState({
    url: url ?? "",
    title: title ?? "",
  });

  useEffect(() => {
    if (!url && !title) {
      setContent({
        title: document.title,
        url: window.location.href,
      });
    }
  }, [url, title]);

  return (
    <div className="flex gap-2">
      <WhatsappShareButton url={content.url} title={content.title}>
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>

      <FacebookShareButton url={content.url} title={content.title}>
        <FacebookIcon size={32} round={true} />
      </FacebookShareButton>

      <LinkedinShareButton url={content.url} title={content.title}>
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>

      <TwitterShareButton url={content.url} title={content.title}>
        <TwitterIcon size={32} round={true} />
      </TwitterShareButton>

      <EmailShareButton url={content.url} subject={content.title}>
        <EmailIcon size={32} round={true} />
      </EmailShareButton>
    </div>
  );
};

export default SocialShare;
